import comp from "./TreeView";
export default comp;
